export const elementGroupRequirements = [
  {
    apparatus: "FX",
    "EG I": "Non-acrobatic elements",
    "EG II": "Acrobatic elements forward",
    "EG III": "Acrobatic elements backward",
    "EG IV": "Dismount",
    "EG Bonus": {
      "EG I": 0.5,
      "EG II": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG III": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG IV": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      }
    }
  },
  {
    apparatus: "PH",
    "EG I": "Single leg swings & scissors",
    "EG II": "Circles & flairs",
    "EG III": "Travels & combined elements",
    "EG IV": "Dismount",
    "EG Bonus": {
      "EG I": 0.5,
      "EG II": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG III": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG IV": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      }
    }
  },
  {
    apparatus: "PL",
    "EG I": "Single leg swings & scissors (pommelless)",
    "EG II": "Circles & flairs (pommelless)",
    "EG III": "Travels & combined elements (pommelless)",
    "EG IV": "Dismount (pommelless)",
    "EG Bonus": {
      "EG I": 0.5,
      "EG II": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG III": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG IV": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      }
    }
  },
  {
    apparatus: "SR",
    "EG I": "Kip & swing elements",
    "EG II": "Strength & hold elements",
    "EG III": "Swing to strength or swing elements",
    "EG IV": "Dismount",
    "EG Bonus": {
      "EG I": 0.5,
      "EG II": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG III": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG IV": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      }
    }
  },
  {
    apparatus: "VT",
    "EG I": "Vault Group 1",
    "EG II": "Vault Group 2",
    "EG III": "Vault Group 3",
    "EG IV": "N/A",
    "EG Bonus": "Not applicable for Vault — vault value only"
  },
  {
    apparatus: "PB",
    "EG I": "Elements in support",
    "EG II": "Elements in upper arm",
    "EG III": "Long swings & underswings",
    "EG IV": "Dismount",
    "EG Bonus": {
      "EG I": 0.5,
      "EG II": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG III": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG IV": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      }
    }
  },
  {
    apparatus: "HB",
    "EG I": "Long hang swings & turns",
    "EG II": "Flight elements",
    "EG III": "In-bar and Adler elements",
    "EG IV": "Dismount",
    "EG Bonus": {
      "EG I": 0.5,
      "EG II": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG III": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      },
      "EG IV": {
        "A/B/C": 0.3,
        "D or higher": 0.5
      }
    }
  }
];
